var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00b6ed",
    d: "M 374.957031 187.457031 C 374.957031 291.0625 291.035156 375 187.5 375 C 129.492188 375 77.726562 348.675781 43.332031 307.308594 C 17.636719 276.429688 1.714844 237.144531 0.207031 194.253906 C 0.117188 192.027344 0.0429688 189.695312 0.0429688 187.457031 C 0.0429688 83.933594 83.964844 0 187.5 0 C 208.785156 0 229.1875 3.515625 248.230469 10.078125 C 287.753906 23.597656 321.269531 49.921875 343.914062 84.167969 C 363.515625 113.773438 374.957031 149.296875 374.957031 187.457031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 150.695312 67.359375 C 150.695312 67.359375 99.199219 68.039062 99.867188 114.730469 C 100.535156 161.421875 109.902344 202.707031 125.285156 225.71875 C 140.667969 248.726562 180.117188 308.957031 224.929688 302.867188 C 224.929688 302.867188 247 298.128906 263.71875 287.296875 L 209.546875 244.664062 C 209.546875 244.664062 193.5 254.816406 183.464844 241.277344 C 173.433594 227.742188 142.003906 164.8125 142.003906 164.8125 C 142.003906 164.8125 133.308594 144.507812 152.703125 135.710938 Z M 150.695312 67.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 156.71875 67.359375 C 156.71875 67.359375 160.730469 66.011719 168.085938 70.070312 C 175.4375 74.125 175.441406 77.507812 175.441406 77.507812 L 176.109375 124.207031 C 176.109375 124.207031 174.101562 126.914062 171.429688 129.617188 C 168.753906 132.324219 160.058594 136.386719 158.71875 133.679688 C 157.386719 130.976562 156.71875 67.359375 156.71875 67.359375 Z M 156.71875 67.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 214.050781 239.671875 L 228.945312 231.804688 C 228.945312 231.804688 232.285156 231.132812 237.636719 234.511719 C 242.984375 237.902344 271.074219 260.234375 271.074219 260.234375 C 271.074219 260.234375 275.757812 264.292969 274.417969 269.03125 C 273.082031 273.769531 269.738281 283.921875 269.738281 283.921875 Z M 214.050781 239.671875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFull);
export default __webpack_public_path__ + "static/media/phone_full.ab80f460e6394f3ddbd692e20da745eb.svg";
export { ForwardRef as ReactComponent };